import { Component } from '@angular/core';

@Component({
  selector: 'rid-vertical-spacer',
  imports: [],
  templateUrl: './rid-vertical-spacer.html',
})
export class RidVerticalSpacer {}
